import React from "react";
import Main from "../pages/Main/Main";

/**
 * "Блок" как виджет на канвасе — это буквально существующий Main.jsx,
 * без единой правки внутри него.
 *
 * Main.jsx исторически ждёт props.match.params.id (легаси react-router
 * паттерн, см. App.jsx: <Main path="/main/:id" exact />), поэтому вместо
 * рефакторинга самого компонента просто передаём такую же форму пропсов.
 *
 * ИЗВЕСТНОЕ ОГРАНИЧЕНИЕ: внутри Main.jsx графики/ResizableBox сейчас
 * считают размеры от window.innerWidth/innerHeight, а не от размера
 * родительского контейнера. Внутри узкой grid-ячейки это будет выглядеть
 * некорректно (контент будет "хотеть" полноэкранный размер). Встроить
 * в канвас можно уже сейчас — но чтобы виджет красиво резайзился вместе
 * с ячейкой, потребуется отдельно завести на container-relative размеры
 * (ResizeObserver вместо window resize listener) внутри самого Main.jsx.
 * Это первая точка, которую стоит доработать.
 */
function UnitBlockWidget({ unitId }) {
	const fakeMatch = { params: { id: String(unitId) } };
	return <Main match={fakeMatch} />;
}

export default UnitBlockWidget;
